import { generateClient } from 'aws-amplify/api';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';
import * as mutations from '../graphql/mutations';
import * as queries from '../graphql/queries';

const client = generateClient();

const getExistingResults = async (username) => {
  const user = await getCurrentUser();
  if (!user) {
    throw new Error('User not authenticated');
  }

  const attributes = await fetchUserAttributes();
  const sub = attributes.sub;

  const { data } = await client.graphql({
    query: queries.listMBTIQuizResults,
    variables: {
      filter: { userId: { eq: sub } }
    },
    authMode: 'userPool'
  });

  if (data.listMBTIQuizResults.items.length > 0) {
    return data.listMBTIQuizResults.items[0];
  }

  return null;
};

const isEqual = (existingResults, newResults) => {
  if (!existingResults) return false;

  return (
    existingResults.personalityType === newResults.personalityType &&
    existingResults.recommendedSpecialties === JSON.stringify(newResults.recommendedSpecialties) &&
    existingResults.scoreBreakdown === JSON.stringify(newResults.scores)
  );
};

export const saveMBTIResults = async (personalityType, recommendedSpecialties, scores, username) => {
  try {
    const existingResults = await getExistingResults(username);
    if (isEqual(existingResults, { personalityType, recommendedSpecialties, scores })) {
      return existingResults; // Skip update if nothing changed
    }

    const user = await getCurrentUser();
    if (!user) {
      throw new Error('User not authenticated');
    }

    const attributes = await fetchUserAttributes();
    const sub = attributes.sub;

    // Log the input data for debugging
    console.log('Saving MBTI results with:', {
      userId: sub,
      personalityType,
      recommendedSpecialties,
      scores,
      username
    });

    const input = {
      userId: sub,
      personalityType,
      recommendedSpecialties: JSON.stringify(recommendedSpecialties),
      scoreBreakdown: JSON.stringify(scores),
      owner: username
    };

    if (existingResults) {
      console.log('Found existing result:', existingResults.id);

      return await client.graphql({
        query: mutations.updateMBTIQuizResult,
        variables: {
          input: {
            id: existingResults.id,
            ...input,
            _version: existingResults._version
          }
        },
        authMode: 'userPool'
      });
    }

    console.log('Creating new result with:', input);
    const result = await client.graphql({
      query: mutations.createMBTIQuizResult,
      variables: { input },
      authMode: 'userPool'
    });

    console.log('Save result:', result);
    return result;

  } catch (error) {
    console.error('Detailed error:', {
      message: error.message,
      name: error.name,
      stack: error.stack,
      details: error
    });
    throw new Error('Failed to save results: ' + error.message);
  }
};
